import {Component, EventEmitter, Input, OnInit, SimpleChanges} from '@angular/core';
import {FieldDefinition} from "@shared/models/field-definition";
import {CellComponent} from "@shared/components/cell-components/cell-component";
import { InvalidateSubject } from '@shared/helpers/invalidate.subject';


@Component({
    standalone: false,
    selector: 'app-cbc-tl-letter-cell-viewer',
  templateUrl: './cbc-tl-letter-cell-viewer.component.html',
  styleUrls: ['./cbc-tl-letter-cell-viewer.component.scss']
})
export class CbcTlLetterCellViewerComponent implements OnInit, CellComponent {

  item: any;
  fieldDefinition: any;
  sourceType: string;
  valueChanged: EventEmitter<any> = new EventEmitter();



  constructor(
  ) {
  }
  validationChange?: EventEmitter<boolean>;
  invalidateSubject?: InvalidateSubject;
  disabled?: boolean;
  extras?: any;

  ngOnInit() {
    console.log("Yes");
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  generateTL() {
    this.valueChanged.emit({item: this.item, fieldDefinition: this.fieldDefinition, action: {id: 'GenerateTlLetter'}})
  }

  editClicked() {
  }
}
